import types from '../type/types.js'

export const setState = state => ({
    type: types.SET_STATE,
    payload: state
})

export default {}